import React, { useState } from 'react';
import { connect } from 'react-redux';
import UserActions from 'store/reducers/User';
import _ from 'lodash';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import ParticipantService from 'api/Participant';
import { useSubmit } from 'hooks';
import { formatDataPhoneToSend } from 'utils';
import SettingsActions from "store/reducers/Settings";

import ProfileView from 'views/Profile';


const Profile = ( {
  user, history, updateUser, switchLanguage,
} ) => {
  const [isLoading, setIsLoading] = useState( false );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => ( ParticipantService.updateParticipant( user.id, dataToSend ) ),
    format: ( dataToFormat ) => {
      let dataToSend = dataToFormat;
      if ( dataToFormat.phone ) {
        const phoneCountryCode = parsePhoneNumberFromString( dataToFormat.phone );
        dataToSend = formatDataPhoneToSend( dataToSend, ['phone'] );
        dataToSend.phoneCountryCode = phoneCountryCode ? phoneCountryCode.countryCallingCode : null;

      } 
      // dataToSend.currencySymbol = dataToSend.currencyName === 'euro' ? '€' : '$'
      return ( dataToSend );
    },
    toggleLoading: () => {
      setIsLoading( ( d ) => !d );
    },
    callback: ( formData, responseData, dToSend ) => {
      updateUser( dToSend );
      switchLanguage({
        locale: dToSend.language,
        name: dToSend.language==="en"?"english":"spanish",
      })
      history.push( '/' );
      setTimeout(()=>{
        window.location.reload()
      },500)
    },
  } );

  return (
    <ProfileView
      data={user}
      isLoading={isLoading}
      onSubmit={submitForm}
    />
  );
};

const mapStateToProps = ( { account, user, settings } ) => ( {
  user,
  accountFirstPrice: account && account.currentPlan ? account.currentPlan.firstPrice : 0,
  locale: _.get( settings, 'locale.locale' ),
} );

const mapDispatchToProps = ( {
  updateUser: UserActions.updateUser,
  switchLanguage: SettingsActions.switchLanguage,
} );

export default connect( mapStateToProps, mapDispatchToProps )( Profile );
